"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$primar, _theme$palette2, _theme$palette3, _theme$palette3$prima, _theme$palette4, _theme$palette4$backg;
  return {
    headline: {
      margin: theme.spacing(0, 0, 2)
    },
    tableHeaderCell: {
      background: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main,
      color: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.getContrastText((_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$prima = _theme$palette3.primary) === null || _theme$palette3$prima === void 0 ? void 0 : _theme$palette3$prima.main),
      whiteSpace: "pre-line"
    },
    container: {
      maxHeight: "none"
    },
    table: {
      minWidth: 650
    },
    tableCell: {
      background: (_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 ? void 0 : (_theme$palette4$backg = _theme$palette4.background) === null || _theme$palette4$backg === void 0 ? void 0 : _theme$palette4$backg.default,
      paddingBottom: theme.spacing(1.5),
      paddingTop: theme.spacing(1.5),
      whiteSpace: "pre-line"
    },
    tableCellSticky: _defineProperty({
      left: 0,
      position: "sticky",
      whiteSpace: "pre-wrap",
      zIndex: 3
    }, theme.breakpoints.down("md"), {
      maxWidth: 170,
      minWidth: 170,
      width: 170
    }),
    tableWrapper: {
      position: "relative"
    },
    tableFooter: {
      marginTop: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  };
});
var _default = styles;
exports.default = _default;